/* Fashly – collection infinite scroll (v3)
 * - One request per page (no duplicates)
 * - Back button: jumps straight back to where the shopper was, missing pages load in parallel
 * - Load trigger can't be hidden by theme CSS
 * - Never gets stuck "loading"; tap-to-retry on network errors
 */
(function () {
  "use strict";

  var GRID_SEL = "ul.grid.product-grid, .product-grid, .collection-product-grid";
  var grid = document.querySelector(GRID_SEL);
  var pagination = document.querySelector(".pagination-wrapper");
  if (!grid || !pagination) return;

  function getNextUrl(container) {
    var a =
      container.querySelector('a[rel="next"]') ||
      container.querySelector(".pagination__item--next a") ||
      container.querySelector('a[aria-label*="Next"]');
    return a ? a.href : null;
  }
  function pageOf(url) {
    return parseInt(new URL(url, location.href).searchParams.get("page") || "1", 10);
  }

  var nextUrl = getNextUrl(pagination);
  if (!nextUrl) return;
  pagination.style.display = "none";

  var lastLoadedPage = pageOf(nextUrl) - 1;
  var STORE_KEY = "fashly-inf:" + location.pathname + location.search;

  // Decide right away whether to restore the shopper's position, and stop the browser jumping to the top.
  // Restore on Back, or when the cart page's "Continue shopping" sent the shopper here (continue-shopping.js).
  var nav = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
  var saved = null;
  var fromCart = false;
  try {
    fromCart = sessionStorage.getItem("fc-inf-restore") === STORE_KEY;
    sessionStorage.removeItem("fc-inf-restore");
  } catch (e) {}
  if ((nav && nav.type === "back_forward") || fromCart) {
    try {
      saved = JSON.parse(sessionStorage.getItem(STORE_KEY));
    } catch (e) {}
  }
  if (saved && "scrollRestoration" in history) history.scrollRestoration = "manual";

  // Trigger + loader sit after the grid. Inline !important stops Dawn's "div:empty {display:none}".
  var trigger = document.createElement("div");
  trigger.setAttribute("aria-hidden", "true");
  trigger.style.setProperty("display", "block", "important");
  trigger.style.setProperty("height", "1px", "important");
  var loader = document.createElement("div");
  loader.id = "infinite-loader";
  loader.style.cssText = "text-align:center;padding:20px;font-size:14px;display:none;cursor:default";
  grid.insertAdjacentElement("afterend", loader);
  grid.insertAdjacentElement("afterend", trigger);

  // One request per URL, shared by prefetch, normal loading and restore.
  var cache = new Map();
  function fetchPage(url) {
    if (!cache.has(url)) {
      var p = fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error("HTTP " + r.status);
          return r.text();
        })
        .catch(function (err) {
          cache.delete(url);
          throw err;
        });
      cache.set(url, p);
    }
    return cache.get(url);
  }
  function prefetch() {
    if (nextUrl) fetchPage(nextUrl).catch(function () {});
  }

  // Add one page of products to the grid and work out the next page.
  function appendPage(html, url, animate) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var newGrid = doc.querySelector(GRID_SEL);
    if (newGrid) {
      Array.prototype.slice.call(newGrid.children).forEach(function (item, i) {
        if (animate) {
          item.style.opacity = "0";
          item.style.transform = "translateY(10px)";
          item.style.transition = "all 0.3s ease";
        }
        grid.appendChild(item);
        if (animate) {
          setTimeout(function () {
            item.style.opacity = "1";
            item.style.transform = "translateY(0)";
          }, i * 40);
        }
      });
    }
    lastLoadedPage = pageOf(url);
    var newPagination = doc.querySelector(".pagination-wrapper");
    nextUrl = newGrid && newPagination ? getNextUrl(newPagination) : null;
  }

  function finishIfDone() {
    if (!nextUrl) {
      observer.disconnect();
      loader.textContent = "✓ All products loaded";
      loader.style.display = "block";
    }
  }

  var isLoading = false;
  var failed = false;

  async function loadMore() {
    if (isLoading || !nextUrl) return false;
    isLoading = true;
    failed = false;
    var url = nextUrl;
    loader.style.display = "block";
    loader.style.cursor = "default";
    loader.textContent = "Loading more products...";
    try {
      var html = await fetchPage(url);
      cache.delete(url);
      appendPage(html, url, true);
      if (nextUrl) prefetch();
      return true;
    } catch (err) {
      failed = true;
      loader.textContent = "Couldn't load more products. Tap to try again.";
      loader.style.cursor = "pointer";
      return false;
    } finally {
      isLoading = false;
      loader.style.display = failed ? "block" : "none";
      finishIfDone();
    }
  }

  loader.addEventListener("click", function () {
    if (failed) loadMore();
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !failed) loadMore();
      });
    },
    { rootMargin: "800px 0px" }
  );

  function onScroll() {
    if (isLoading || !nextUrl || failed) return;
    if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 1200) loadMore();
  }

  // Remember where the shopper was when they leave the page.
  function saveState() {
    try {
      sessionStorage.setItem(
        STORE_KEY,
        JSON.stringify({ page: lastLoadedPage, y: window.scrollY, gridH: grid.offsetHeight })
      );
    } catch (e) {}
  }
  grid.addEventListener("click", function (e) {
    if (e.target.closest('a[href*="/products/"]')) saveState();
  }, true);
  window.addEventListener("pagehide", saveState);

  // Back visit: jump to the saved spot at once, then fill in the missing pages in parallel.
  async function restore() {
    if (!saved) return;
    if (saved.gridH) grid.style.minHeight = saved.gridH + "px";
    window.scrollTo(0, saved.y);

    var urls = [];
    for (var p = lastLoadedPage + 1; p <= saved.page; p++) {
      var u = new URL(nextUrl);
      u.searchParams.set("page", String(p));
      urls.push(u.toString());
    }
    var pages = await Promise.all(
      urls.map(function (u) {
        return fetchPage(u).catch(function () {
          return null;
        });
      })
    );
    for (var i = 0; i < pages.length && nextUrl; i++) {
      if (pages[i] == null) break;
      cache.delete(urls[i]);
      appendPage(pages[i], urls[i], false);
    }
    grid.style.minHeight = "";
    window.scrollTo(0, saved.y);
    finishIfDone();
  }

  restore()
    .catch(function () {
      grid.style.minHeight = "";
    })
    .finally(function () {
      if (nextUrl) {
        observer.observe(trigger);
        window.addEventListener("scroll", onScroll, { passive: true });
        prefetch();
      }
    });
})();